import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { Phone, Info, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PlanYourVisitCTA } from '../components/PlanYourVisitCTA';
import { PHONE, PHONE_TEL } from '../constants/business';
export function UsedGunsEstates() {
  useDocumentMeta('Used Guns, Appraisals, Collections & Estates | Kjergaard Sports', 'Sell used guns, get appraisals, and work with Kjergaard Sports on collections and estates in Lake Benton, Minnesota.');
  return <div data-id="element-1306">
      <PageHero title="Used Guns, Appraisals, Collections & Estates" image="https://cdn.magicpatterns.com/uploads/1WmymfCRjNVxeWfAjjuCCR/firearms-cases.jpg" alt="Used firearms case at Kjergaard Sports" data-id="element-1307" />

      <section className="py-20 bg-brand-offwhite" data-id="element-1308">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1309">
          <div className="max-w-3xl mb-16" data-id="element-1310">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-1311">
              Active Buyers of Used Guns, Collections & Estates
            </h2>
            <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-1312">
              Kjergaard Sports likes working with used guns, appraisals,
              collections, and estates. Whether you have a single rifle to sell,
              a small group from a relative's collection, or a full estate that
              needs to be evaluated, we'd like to talk with you.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-1313">
            <div data-id="element-1314">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-1315">
                Selling One Gun or a Small Group
              </h2>
              <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-1316">
                For one-off guns and small batches, bring the firearms in any
                time during business hours. We need to see firearms in person to
                provide a price, so a quick stop is the fastest path to an
                offer.
              </p>
            </div>
            <div data-id="element-1317">
              <img src="https://cdn.magicpatterns.com/uploads/1WmymfCRjNVxeWfAjjuCCR/firearms-cases.jpg" alt="Used firearms display at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-1318" />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-1319">
            <div className="order-2 lg:order-1" data-id="element-1320">
              <img src="https://cdn.magicpatterns.com/uploads/4PEc13YMi3QHpCzosrhrkQ/store-interior-firearms-wide.jpg" alt="Wide view of the firearms floor at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-1321" />
            </div>
            <div className="order-1 lg:order-2" data-id="element-1322">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-1323">
                Large Collections
              </h2>
              <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-1324">
                For larger collections that aren't practical to transport, we
                offer a service where we travel to you to evaluate the firearms
                on-site. Call ahead to discuss scope, location, and timing.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-brand-cream" data-id="element-1325">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1326">
          <Heart className="w-12 h-12 text-brand-leather mx-auto mb-6" data-id="element-1327" />
          <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6 text-center" data-id="element-1328">
            Estates
          </h2>
          <p className="text-lg text-brand-charcoal/80 leading-relaxed text-center" data-id="element-1329">
            We have helped many families work through estates that include
            firearms. The process can feel overwhelming, especially during a
            difficult time. We approach these conversations carefully and
            respectfully, and we'll walk you through your options without
            pressure.
          </p>
        </div>
      </section>

      <section className="py-20 bg-brand-bone" data-id="element-1330">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1331">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-1332">
            <div className="bg-brand-offwhite p-8 rounded-sm border border-brand-cream" data-id="element-1333">
              <h3 className="text-2xl font-serif text-brand-charcoal mb-4" data-id="element-1334">
                Appraisals
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-1335">
                Appraisal fees vary depending on several factors including the
                size of the collection, travel involved, and the type of
                firearms being evaluated. If we're able to reach a deal and
                purchase the collection, the appraisal fee is waived.
              </p>
            </div>
            <div className="bg-brand-offwhite p-8 rounded-sm border border-brand-cream" data-id="element-1336">
              <h3 className="text-2xl font-serif text-brand-charcoal mb-4" data-id="element-1337">
                We Need to See It In Person
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-1338">
                We don't quote prices over the phone or by photo. Firearm
                condition is critical to value, and we want to give you an
                honest, accurate offer — which means seeing the firearm in our
                hands.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-brand-offwhite" data-id="element-1339">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1340">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-1341">
            Call About Large Collections
          </h2>
          <p className="text-lg text-brand-charcoal/80 mb-10 leading-relaxed" data-id="element-1342">
            For larger collections or estates, give us a call so we can plan
            travel, timing, and what to expect.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8" data-id="element-1343">
            <a href={PHONE_TEL} className="bg-brand-hunter hover:bg-brand-wood text-brand-offwhite px-7 py-3.5 rounded-sm font-medium transition-colors inline-flex items-center justify-center" data-id="element-1344">
              <Phone className="w-5 h-5 mr-2" data-id="element-1345" />
              Call the Store
            </a>
            <Link to="/contact" className="border-2 border-brand-hunter text-brand-hunter hover:bg-brand-hunter hover:text-brand-offwhite px-7 py-3.5 rounded-sm font-medium transition-colors inline-flex items-center justify-center" data-id="element-1346">
              Ask About a Collection
            </Link>
            <Link to="/contact" className="border border-brand-charcoal/20 hover:border-brand-leather text-brand-charcoal px-7 py-3.5 rounded-sm font-medium transition-colors inline-flex items-center justify-center" data-id="element-1347">
              Plan Your Visit
            </Link>
          </div>

          <div className="bg-brand-cream border-l-4 border-brand-leather p-6 text-left max-w-2xl mx-auto" data-id="element-1348">
            <div className="flex items-start" data-id="element-1349">
              <Info className="w-5 h-5 text-brand-leather mr-3 flex-shrink-0 mt-0.5" data-id="element-1350" />
              <p className="text-brand-charcoal/85 text-sm leading-relaxed" data-id="element-1351">
                All firearm-related sales, purchases, and transfers are handled
                in accordance with applicable federal, state, and local laws.
                Information on this page is general information only and is not
                legal advice.
              </p>
            </div>
          </div>
        </div>
      </section>

      <PlanYourVisitCTA data-id="element-1352" />
    </div>;
}